<template>
  <div class="px-4 py-4">
    <div>
        <SynergyScoreDetails></SynergyScoreDetails>
        <br><br>
        Significance values of the synergy scores, where each score is normalized to its estimated standard error and the resulting calculated z-score is used to compute a q value (under the assumption of a standard normal null and corrected for multiple hypothesis testing using Benjamini-Hochberg method). The standard error of the measured LMFI values for each cell line and plate pair are assumed to be roughly the same across different perturbations and therefore can be estimated using the DMSO replicates. In particular, the standard errors are calculated for each cell line by multiplying the standard deviation across negative control samples (~32 replicates) by an appropriate constant (<span class="math-block"><vue-mathjax :formula="'$$C$$'"></vue-mathjax></span>) . In interpreting the synergy scores, we recommend focusing more on effect size after providing a generous threshold on the q-values (i.e. 0.05 or 0.01). 
        <br><br>
        Cases where the observed combination LFC is below the dynamic range of the assay can result in a misleading antagonistic interaction between the two compounds (artificial antagonism). These points have a value of 1 in the Artificial Antagonism Flag table column.<br><br>
    </div>
  </div>
</template>

<script>
import * as portalContent from '@/js/models/portal-content.js';
import SynergyScoreDetails from '@/dynamic-content/SynergyScoreDetails.vue';

export default {
  name: 'synergy-by-dose-drawer',
  components: {
    SynergyScoreDetails
},
  data: () => ({
    formula: {
      rect_area: "$$\\approx\\frac{1}{d_2-d_1}FC_{d_1}$$",
      auc: "$$AUC \\approx\\frac{1}{n*(d_2 -d_1)}\\sum_{i=1}^nFC_{d_i}(d_{i+1} - d_i)\\approx\\frac{1}{n}\\sum_{i=1}^nFC_{d_i}$$",
      bliss_auc: "$$AUC_{bliss}\\approx \\frac{1}{n}\\sum_{i=1}^nFC_{a_i}FC_b$$",
      combo_auc: "$$AUC_{combo} \\approx\\frac{1}{n}\\sum_{i=1}^nFC_{c_i}$$",
    }
  

  }),
  computed:{
    meta(){
          const section_id = "synergy-by-dose";
          const screen = this.$route.params.screen;
          const version_meta = portalContent.getVersionMetadata(screen, section_id);
          return version_meta
        }
  },
  mounted() {

  },
  methods: {},
  watch: {}
}
</script>

<style>
h3{
  font-weight:700 !important;
}
p{
  line-height:1.75em;
}
.math-block{
  width:auto;
  display:inline-block;
}
.MathJax_Display{
  width:100% !important;
  display:inline-block !important;
}

</style>
